<div cdkDrag cdkDragBoundary=".cdk-overlay-container"
     cdkDragRootElement=".dialog-box.settings">
  <div cdkDragHandle mat-dialog-title>
    <mat-icon>settings</mat-icon>
    <h1>{{ globals.titles.settings }}</h1>
    <app-close-button [data]="closeData"></app-close-button>
  </div>
  <mat-dialog-content>
    <app-person-form [data]="personData" [pageName]="pageKeyPerson" startFocus="person_email"></app-person-form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button (click)="clickSave()" mat-button>
      <mat-icon>save</mat-icon>
      <span i18n>Save</span>
    </button>
    <button (click)="clickPassword()" mat-button>
      <mat-icon>key</mat-icon>
      <span i18n>Password</span>
    </button>
  </mat-dialog-actions>
</div>
